import { push } from "connected-react-router";
import { put, takeEvery } from "redux-saga/effects";

import { addNotification, loading } from "layouts/AppLayout/modules";
import { getApi } from "../../../sagas";
import { UPLOAD_TEMPLATE, UploadTemplateAction, uploadTemplateEnd } from "../actions";

export function* uploadTemplate(action: UploadTemplateAction) {
    const { payload } = action;
    const { template, selectOnSuccess } = payload;

    const api = getApi(payload);

    try {
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const result = yield api.uploadTemplate(template);
        const { app, intents } = result;
        yield put(uploadTemplateEnd(undefined, app, intents));

        if (selectOnSuccess) {
            yield put(push(`/${app.organizationId}/${app.appId}`));
        }
    } catch (e) {
        yield put(addNotification(e.message, true));
        yield put(uploadTemplateEnd(e));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchUploadTemplate() {
    yield takeEvery(UPLOAD_TEMPLATE, uploadTemplate);
}
